import { useUser } from "@/zustand-hooks/user-hook";

/**
 * Хук для проверки разрешений клиента
 * Использует настройки из clientSettings, полученные через /refresh/customer
 */
export const useCustomerPermissions = () => {
    const { clientSettings } = useUser();

    return {
        // Отображение вкладок и функций
        exchangeTabEnabled: clientSettings?.permissions?.exchangeTabEnabled ?? true,
        depositMethodsEnabled: clientSettings?.permissions?.depositMethodsEnabled ?? true,
        depositCardEnabled: clientSettings?.permissions?.depositCardEnabled ?? true,
        depositBankEnabled: clientSettings?.permissions?.depositBankEnabled ?? true,
        depositCryptoEnabled: clientSettings?.permissions?.depositCryptoEnabled ?? true,
        withdrawMethodsEnabled: clientSettings?.permissions?.withdrawMethodsEnabled ?? true,
        withdrawCardEnabled: clientSettings?.permissions?.withdrawCardEnabled ?? true,
        withdrawBankEnabled: clientSettings?.permissions?.withdrawBankEnabled ?? true,
        withdrawCryptoEnabled: clientSettings?.permissions?.withdrawCryptoEnabled ?? true,
        accountsTabEnabled: clientSettings?.permissions?.accountsTabEnabled ?? true,
        
        // Разрешения на изменение данных
        changePasswordAllowed: clientSettings?.permissions?.changePasswordAllowed ?? true,
        changePersonalDataAllowed: clientSettings?.permissions?.changePersonalDataAllowed ?? true
    };
};

export default useCustomerPermissions;

